<template>
  <table-task :config="tableConfig" :manager="manager" />
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import type { TasksScreenManager } from '@/logic/TasksScreen'

import { TASK_TYPE_INSPECTION } from '@/constants'

import TableTask from './TableTask.vue'
// import TableHeadActionsBase from './TableHeadActionsBase.vue';
import TableHeadStatusBase from './TableHeadStatusBase.vue'
import TableHeadDataInspection from './TableHeadDataInspection.vue'
import TableRowBase from './TableRowBase.vue'
import TableHeadActionsInstallation from './TableHeadActionsInstallation.vue'

@Component({
  name: 'InspectionTable',
  components: {
    TableTask,
  },
})
export default class InspectionTable extends Vue {
  @Prop() manager!: TasksScreenManager

  protected tableConfig = {
    headers: [
      {
        component: TableHeadStatusBase,
        props: {
          manager: this.manager,
          type: TASK_TYPE_INSPECTION,
        },
        width: '20%',
      },
      {
        component: TableHeadDataInspection,
        props: {
          manager: this.manager,
        },
      },
      {
        component: TableHeadActionsInstallation, // uses same special actions as installations
        props: {
          manager: this.manager,
          type: TASK_TYPE_INSPECTION,
        },
        width: '25%',
      },
    ],
    row: {
      component: TableRowBase,
      props: {
        manager: this.manager,
        type: TASK_TYPE_INSPECTION,
      },
    },
  }
}
</script>
